var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9432 10.603C29.7884 10.1345 29.3709 9.79806 28.828 9.70117L20.3796 8.20942C20.3567 8.19983 20.3153 8.17215 20.2957 8.15085L16.2241 0.760249C15.9636 0.28323 15.5068 0 15.0032 0C14.4984 0 14.0428 0.284295 13.7822 0.759185L9.71608 8.14553C9.69864 8.16576 9.65177 8.19983 9.66158 8.19983L1.17828 9.70117C0.636489 9.79806 0.220063 10.1335 0.0641765 10.5998C-0.0928006 11.0662 0.0423741 11.5784 0.423916 11.9713L6.39667 18.098L5.23788 26.4437C5.16484 26.9782 5.36215 27.4691 5.76877 27.7566C5.99551 27.9184 6.26477 27.9993 6.54275 27.9993C6.76404 27.9993 6.99297 27.9482 7.21426 27.8439L14.9465 24.2023C14.9737 24.1959 15.0326 24.1959 15.0271 24.1896L22.7953 27.8449C23.2924 28.0781 23.832 28.0451 24.2376 27.7566C24.6431 27.4691 24.8426 26.9782 24.7684 26.4426L23.6129 18.1321C23.614 18.1076 23.6304 18.0554 23.6249 18.0554L23.6238 18.0565L29.5813 11.9713C29.9639 11.5816 30.0991 11.0694 29.9432 10.603Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingfill);
export default __webpack_public_path__ + "static/media/ratingfill.6de8eaa38e1a6377e8b1ce54a830672e.svg";
export { ForwardRef as ReactComponent };